import _ from 'lodash';
import { colors, type } from '@nerdwallet/base-styles/variables';

// Layout
const baseProps = {
  width: 560,
  height: 280,
  padding: {
    top: 36,
    bottom: 48,
    left: 64,
    right: 16,
  },
};

// Labels
const baseLabelStyles = {
  fill: colors['neutral-dark'],
  fontFamily: type['font-family-gotham'],
  fontSize: 12,
  letterSpacing: 'normal',
  stroke: 'transparent',
};

const centeredLabelStyles = _.assign(baseLabelStyles, { textAnchor: 'middle' });

export const dashboardChartTheme = {
  axis: _.assign(
    {
      style: {
        axis: {
          fill: 'transparent',
          stroke: 'transparent',
          strokeWidth: 1,
        },
        axisLabel: _.assign({}, centeredLabelStyles),
        grid: {
          fill: 'none',
          stroke: 'none',
          pointerEvents: 'visible',
        },
        ticks: {
          fill: 'transparent',
          size: 1,
          stroke: 'transparent',
        },
        tickLabels: _.assign({}, baseLabelStyles),
      },
    },
    baseProps,
  ),
  chart: _.assign({}, baseProps),
  line: _.assign(
    {
      style: {
        data: {
          fill: 'transparent',
          stroke: colors['neutral-dark'],
          strokeWidth: 1,
        },
        labels: _.assign({}, centeredLabelStyles),
      },
    },
    baseProps,
  ),
};
